module.exports = __webpack_public_path__ + "static/media/ship.c4836b38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameShipPainting/ship.png
// module id = 2471
// module chunks = 0